import mapValues from 'lodash.mapvalues';
import groupBy from 'lodash.groupby';

/**
 * Sort array of objects based on another array
 */

export function mapOrder (array, order, key) {
  
    array.sort( function (a, b) {
    	var A = a[key], B = b[key];
      
    	if (order.indexOf(A) > order.indexOf(B)) {
        	return 1;
      	} else {
        	return -1;
      	} 
    });
    
    return array;
};

/**
 * Unique array items
 */
export const uniqEs6 = (arrArg) => {
    return arrArg.filter((elem, pos, arr) => {
		  return arr.indexOf(elem) == pos;
    });
}

/**
 * Flatten array of objects with children key
*/
export const flatten = function(obj) {
  const array = Array.isArray(obj) ? obj : [obj];
  return array.reduce(function(acc, value) {
    acc.push(value);
    if (value.children) {
    	acc = acc.concat(flatten(value.children));
    	delete value.children;
    }
    return acc;
  }, []);
}

export const unflatten = function(arr, key = 'nested', primaryKey = 'id') {
    let tree = [],
        mappedArr = {},
        arrElem,
        mappedElem;

    // First map the nodes of the array to an object -> create a hash table.
    for(let i = 0, len = arr.length; i < len; i++) {
        arrElem = arr[i];
        mappedArr[arrElem[primaryKey]] = arrElem;
        //mappedArr[arrElem.id]['nested'] = [];
    }
    for (let id in mappedArr) {
        if (mappedArr.hasOwnProperty(id)) {
            mappedElem = mappedArr[id];
            // If the element is not at the root level, add it to its parent array of children.
            if (mappedElem.parent_id && mappedArr[mappedElem['parent_id']]) {
                if(!mappedArr[mappedElem['parent_id']][key]){
                    mappedArr[mappedElem['parent_id']][key] = [];
                }
                mappedArr[mappedElem['parent_id']][key].push(mappedElem);
            }
            // If the element is at the root level, add it to first level elements array.
            else {
                tree.push(mappedElem);
            }
        }
    }
    return tree;
}

export const flattenChildren = function(obj) {
    const array = Array.isArray(obj) ? obj : [obj];
    return array.reduce(function(acc, value) {
        if (!value.children) {
            acc.push(value);
        }else {
          acc = acc.concat(value.children);
          //delete value.children;
      }
      return acc;
    }, []);
  }

/**
 * Find item path in nested tree array
*/
export const findRoute = (routes, route_url) => {

	let path = [];

	const findDeep = (data, url) => {
		return data.some((e, index) => {
			if(e.url == url){
				return true; 
			}else if(e.children){
				const result = findDeep(e.children, url);
				if(result){
					path.push(e);
				}
				return result;
			}
		});
	}

	findDeep(routes, route_url);

	return path.reverse();

}

/**
 * Nest data grouping by selected keys
*/
export const nest = (seq, keys) => {
    if (!keys.length){
	    return seq;
	}
    var first = keys[0];
    var rest = keys.slice(1);
    return mapValues(groupBy(seq, first), (value) => { 
        return nest(value, rest);
    });
};

export const criteriaFilter = (arr, criteria) => {
    return arr.filter(function(obj) {
      return Object.keys(criteria).every(function(c) {
        return obj[c] == criteria[c];
      });
    });
}

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var defaultConfig = {
    id: "id",
    parentId: "parent_id",
    dataField: null,
    childrenField: "children",
    throwIfOrphans: false,
    rootParentIds: { "": true },
};
/**
 * Unflattens an array to a tree with runtime O(n)
 */
export const  arrayToTree = (items, config) => {
    var _a, _b, _c;
    if (config === void 0) { config = {}; }
    var conf = __assign(__assign({}, defaultConfig), config);
    // the resulting unflattened tree
    var rootItems = [];
    // stores all already processed items with their ids as key so we can easily look them up
    var lookup = {};
    // stores all item ids that have not been added to the resulting unflattened tree yet
    // this is an opt-in property, since it has a slight runtime overhead
    var orphanIds = config.throwIfOrphans
        ? new Set()
        : null;
    // idea of this loop:
    // whenever an item has a parent, but the parent is not yet in the lookup object, we store a preliminary parent
    // in the lookup object and fill it with the data of the parent later
    // if an item has no parentId, add it as a root element to rootItems
    for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
        var item = items_1[_i];
        var itemId = getNestedProperty(item, conf.id);
        var parentId = getNestedProperty(item, conf.parentId);
        if (conf.rootParentIds[itemId]) {
            throw new Error("The item array contains a node whose parentId both exists in another node and is in " +
                ("`rootParentIds` (`itemId`: \"" + itemId + "\", `rootParentIds`: " + Object.keys(conf.rootParentIds)
                    .map(function (r) { return "\"" + r + "\""; })
                    .join(", ") + ")."));
        }
        // look whether item already exists in the lookup table
        if (!Object.prototype.hasOwnProperty.call(lookup, itemId)) {
            // item is not yet there, so add a preliminary item (its data will be added later)
            lookup[itemId] = (_a = {}, _a[conf.childrenField] = [], _a);
        }
        // if we track orphans, delete this item from the orphan set if it is in it
        if (orphanIds) {
            orphanIds.delete(itemId);
        }
        // add the current item's data to the item in the lookup table
        if (conf.dataField) {
            lookup[itemId][conf.dataField] = item;
        }
        else {
            lookup[itemId] = __assign(__assign({}, item), (_b = {}, _b[conf.childrenField] = lookup[itemId][conf.childrenField], _b));
        }
        var treeItem = lookup[itemId];
        if (parentId === null ||
            parentId === undefined ||
            conf.rootParentIds[parentId]) {
            // is a root item
            rootItems.push(treeItem);
        }
        else {
            // has a parent
            // look whether the parent already exists in the lookup table
            if (!Object.prototype.hasOwnProperty.call(lookup, parentId)) {
                // parent is not yet there, so add a preliminary parent (its data will be added later)
                lookup[parentId] = (_c = {}, _c[conf.childrenField] = [], _c);
                // if we track orphans, add the generated parent to the orphan list
                if (orphanIds) {
                    orphanIds.add(parentId);
                }
            }
            // add the current item to the parent
            lookup[parentId][conf.childrenField].push(treeItem);
        }
    }
    if (orphanIds === null || orphanIds === void 0 ? void 0 : orphanIds.size) {
        throw new Error("The items array contains orphans that point to the following parentIds: " +
            ("[" + Array.from(orphanIds) + "]. These parentIds do not exist in the items array. Hint: prevent orphans to result ") +
            "in an error by passing the following option: { throwIfOrphans: false }");
    }
    return rootItems;
}
/**
 * Returns the value of a nested property inside an item
 * Example: user can access 'id', or 'parentId' inside item = { nestedObject: { id: 'myId', parentId: 'myParentId' } }
 * using getNestedItemProperty(item, 'nestedObject.id') or getNestedItemProperty(item, 'nestedObject.parentId')
 * @param item
 * @param nestedProperty the chained properties to access the nested property. Eg: 'your.nested.property'
 */
function getNestedProperty(item, nestedProperty) {
    return nestedProperty.split(".").reduce(function (o, i) { return o[i]; }, item);
}

export const convertArrayToObject = (array, key) => {
    const initialValue = {};
    return array.reduce((obj, item) => {
      return {
        ...obj,
        [item[key]]: item,
      };
    }, initialValue);
  };